import { Col } from 'antd';
import React from 'react';
import { SearchFilter, SearchFilterContainer } from '../filters';
export const ApexClassSearch = ({ onChange }) => React.createElement(SearchFilterContainer, null,
    React.createElement(Col, { span: 12 },
        React.createElement(SearchFilter, { onChange: onChange })));
